import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumberValidator {

  /**
   * Checks if the input string 'currency' is a valid value with mask [1200,34]
   * @param currency
   * @returns true or false
   */
  public static isValidComma2Decimal(currency: String) {
    if (currency == null || currency.trim().length === 0) return false;

    //Validate mask
    if (currency.trim().match(/^\d+(,\d{2})?$/g)) {
      return true;
    }
    return false;
  }

  /**
   * Checks if the input string 'currency' is a valid value with mask [1200.34]
   * @param currency
   * @returns true or false
   */
  public static isValidDot2Decimal(currency: String) {
    if (currency == null || currency.trim().length === 0) return false;

    //Validate mask
    if (currency.trim().match(/^\d+(\.\d{2})?$/g)) {
      return true;
    }
    return false;
  }
}

